import { useEffect, useState } from "react";

// Based on https://stackoverflow.com/questions/57547582/useeffect-with-debounce
// TODO should we use - https://github.com/streamich/react-use/blob/HEAD/docs/useDebounce.md
export function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
